export default __webpack_public_path__ + "img/72c2d66be762f99cce91ba63520acde7.svg";